import type { NestedFilter } from '@@partner:graphql/types'
import { makeFilter, makeSearchFilter } from './crud/filters'

export interface PromocodeFiltersType {
  id?: string
  code?: string
  type?: string
  delivery_discount?: string
}

export const preparePromocodeFilter = (filters: PromocodeFiltersType): NestedFilter => {
  const idFilter = makeFilter('id', 'eq', filters.id ? [ filters.id ] : undefined)
  const codeFilter = makeSearchFilter('code', 'includes', filters.code)
  const typeFilter = makeFilter('type', 'eq', filters.type ? [ filters.type ] : undefined)
  const deliveryDiscountFilter = makeFilter(
    'delivery_discount',
    'eq',
    filters.delivery_discount ? [ parseFloat(filters.delivery_discount) ] : undefined
  )

  return {
    and: [
      // Всегда фильтруем по типу 'promocode'
      {
        fields: [ 'type' ],
        value: [ 'promocode' ],
        op: 'eq'
      },
      idFilter,
      codeFilter,
      typeFilter,
      deliveryDiscountFilter
    ]
  }
}
